import React from 'react';

export function Panel({ title, actions, flush, children }) {
  return (
    <div className="crm-panel">
      {title && (
        <div className="crm-panel-header">
          <h4 className="crm-panel-title">{title}</h4>
          {actions}
        </div>
      )}
      <div className={flush ? 'crm-panel-body-flush' : 'crm-panel-body'}>{children}</div>
    </div>
  );
}

export default Panel;
